export default {
    dashboard: { method: 'GET', url: 'dashboard/init{/id}{/hoje}' },
    fluxo: { method: 'GET', url: 'dashboard/fluxo{/id}{/ano}' },
};